import { FC } from "react";
// 组件
import { ProButton } from '../../../antd';
import ButtonGroup from '../../../ButtonGroup';
// 常量
import { OperationItem, OperationPorps } from "../../interface";
import { CommonlyTypeEnum } from "../../../SuperTable/interface";
import { IBtnList } from "../../../ButtonGroup/buttonGroup";

/** 操作按钮 */
const Operation: FC<OperationPorps> = props => {
  const { record, operation, onClickOperation, } = props;
  const renderButton = (config: OperationItem) => {
    const buttonConfig = typeof config === 'string' ? CommonlyTypeEnum[config] : config as IBtnList;
    if (buttonConfig) {
      const { label, key, ...restConfig } = buttonConfig;
      return (
        <div className="card-table-column-operation">
          <ProButton {...restConfig} onClick={() => onClickOperation?.(key, record)}>{buttonConfig.label}</ProButton>
        </div>
      ); 
    }
    return null;
  };
  if (Array.isArray(operation) && operation.length) {
    return (
      <div className="card-table-column-operation">
        {
          operation.map(group => {
            if (Array.isArray(group)) {
              const btnLists = group.map(item => {
                if (typeof item === 'string') return CommonlyTypeEnum[item];
                return item;
              });
              return (
                <div>
                  <ButtonGroup btnLists={btnLists} onClick={key => onClickOperation?.(key, record)} />
                </div>
              );
            }
            return renderButton(group as OperationItem);
          })
        }
      </div>
    );
  }
  if (operation) return renderButton(operation as OperationItem);
  return null;
};

export default Operation;